import React, { Component } from "react";
import PropTypes from "prop-types";
import axiosClient from "../common/axios_client";

class NotificationMail extends Component  {
  constructor(props) {
    super(props);

    this.state = {
      settingState: Boolean(props.settings.message_mail)
    };
  }

  handleSettingButtonClick = (event) => {
    axiosClient.patch("/api/v1/user/notification_settings/message_mail/notice",
      {
        notification_setting: {
          notice: event.target.childNodes[0].value
        }
      })
      .then(settings => {
        this.setState({
          settingState: settings.data.message_mail
        });
      })
      .catch();
  };

  render () {
    const { settingState } = this.state;

    return (
      <div className='col-3 col-md-2 text-center btn-notify-setting'>
        <div className='mb-1'>メール</div>
        <div className='btn-group btn-group-toggle' data-toggle='buttons'>
          <label
            className={`btn btn-outline-primary ${settingState ? "active" : ""}`}
            htmlFor='message_mail_on'
            onClick={this.handleSettingButtonClick}
          >
            <input
              id='message_mail_on'
              type='radio'
              value='on'
              defaultChecked={settingState}
            />
            {" "}
ON
          </label>
          <label
            className={`btn btn-outline-primary ${!settingState ? "active" : ""}`}
            htmlFor='message_mail_off'
            onClick={this.handleSettingButtonClick}
          >
            <input
              id='message_mail_off'
              type='radio'
              value='off'
              defaultChecked={!settingState}
            />
            {" "}
OFF
          </label>
        </div>
      </div>
    );
  }
}

NotificationMail.propTypes = {
  settings: PropTypes.shape({
    message_mail: PropTypes.bool
  }).isRequired
};

export default NotificationMail;
